<template>
  <div
    id="category-linklist"
    ref="carousel"
    class="category-linklist splide"
    :aria-label="$string('accessibility.quick_links')"
  >
    <div class="splide__track">
      <div v-if="links?.length > 0" class="splide__list">
        <div
          v-for="link of filteredLinks"
          :key="link.title"
          class="splide__slide category-linklist__filter-list-item"
        >
          <a
            :id="link.title + '-category-linklist'"
            :ref="link.active ? 'filterListLink' : null"
            class="category-linklist__filter-list-item-link text-desktop-paragraph-s-regular text-mobile-paragraph-s-regular"
            :class="{ [$class('active')]: link.active }"
            :href="link.url"
            v-text="removeSquareBrackets(link.title)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Category linklist (category-linklist)
 * -----------------------------------------------------------------------------
 * Category linklist.
 *
 * @param {Array} links - List of links.
 *
 */
import { Splide } from '@splidejs/splide';
import { isAccessibleOnMarket, removeBrackets } from '~/helpers/general';

export default {
  name: 'CategoryLinklist',

  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    filteredLinks() {
      return this.links.filter((link) => isAccessibleOnMarket(link.title));
    },
  },

  mounted() {
    if (this.$refs.carousel && this.links.length > 0) {
      // Ensure the Splide carousel is only constructed if there are links to display
      this.constructCarousel();
    }
  },

  methods: {
    removeSquareBrackets(string) {
      return removeBrackets(string);
    },

    constructCarousel() {
      this.carousel = new Splide(this.$refs.carousel, {
        arrows: false,
        drag: true,
        focus: 'left',
        gap: 'var(--spacing-xs)',
        keyboard: true,
        paginationKeyboard: true,
        pagination: false,
        autoWidth: true,
        snap: true,
        speed: this.$timing('normal'),
        type: 'slide',
      });

      this.carousel.mount();

      const activeIndex = this.links.findIndex((link) => link.active);

      this.carousel.go(activeIndex);
    },
  },
};
</script>

<style lang="scss">
@import './category-linklist';
</style>
